import React from 'react';
import Mantra_22_A1_Canvas from './Mantra_22_A1_Canvas';
import { Html2CanvasFunction } from '../../utils/NewHelper';
import Loader from '../loader/loader';

import { showCongratulations } from "../../utils/misc";
import { onImageFileUploaded } from '../../utils/helper';




class Mantra_22_A1_Edit extends React.Component {
    constructor() {
        super();
        this.state = {
            message: null,
            isLoading: false,
        }

    }

    postData = async () => {
        // e.preventDefault();
        this.setState({
            isLoading: true
        })

        if (this.state.message) {

            //canvas this means canvas is all set, read the name and festival and generate canvas now
            // $(".preloader_mantra").show();
            var ref = this;
            let reqdata = {
                type: ref.props.type,
                module_name: ref.props.module_name
            }
            let resData = await Html2CanvasFunction(reqdata)
            resData.addEventListener("load", function (data) {
                data = resData.response;
                data = JSON.parse(data);
                var imageUrl = data.data.cardimage;
                var id = data.data.id;
                ref.setState({
                    "shareData": imageUrl,
                    "id": id, "image": null,
                    isLoading: false
                }, () => {
                    showCongratulations(ref.props.module_name)
                });

                ref.props.onCanVase(imageUrl, id)
                // ref.processShare(data, params, ref);
                onImageFileUploaded({
                    image: imageUrl,
                    module: ref.props.module_name,
                    postid: id
                });
            });
        } else {
            alert('All Fields are required.');
            this.setState({
                isLoading: false
            })
        }
    }


    render() {
        const { message, isLoading } = this.state;

        if (isLoading) {
            return (
                <Loader />
            )
        }

        return (
            <>
                <div className="m3_a1_container container">
                    <div className="">
                        <div className="m3_p_img_prev">
                            <span>Preview</span>
                        </div>

                        <section className="mantra22n_prev_section">
                            <img src="/assets/img/Mantra-22-Activity-1-01.jpg" className="m18_cirt" />
                            <p className="mantra22n_new_p">{message}</p>
                        </section>
                    </div>
                    <section className="m3_form">
                        {/* <div className="m3_form_group active">
                            <label className="m3_label">Name *</label>
                            <input className="m3_input active" type="text" name="yourFriendName" />
                        </div> */}

                        <div className="m3_form_group">
                            <label className="m3_label">Message *</label>
                            <textarea
                                onChange={(e) => { (e.target.value).length <= 350 && this.setState({ message: e.target.value }) }}
                                value={message}
                                className="m11_textarea"
                                type="text"
                                placeholder="Write your message here"
                            ></textarea>
                        </div>
                        <button className="btn_f" onClick={() => this.postData()}>Done & Share</button>
                    </section>
                </div>
                {
                    message &&
                    <Mantra_22_A1_Canvas message={message} module_name={this.props.module_name} />
                }

            </>
        )
    }
}

export default Mantra_22_A1_Edit;